import React from "react";
import styled from "styled-components";

export const StatusBadge = ({ status, text }) => {
  return <Badge status={status}>{text}</Badge>;
};

const Badge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: capitalize;

  ${({ status }) => {
    switch (status) {
      case "active":
      case "success":
      case "completed":
      case "successful":
        return `
          background-color: #DCFCE7;
          color: #166534;
        `;
      case "fulfilled":
      case "warning":
      case "pending":
      case "undecided":
        return `
          background-color: #FEF9C3;
          color: #854D0E;
        `;
      case "expired":
      case "error":
      case "failed":
      case "unsuccessful":
        return `
          background-color: #FEE2E2;
          color: #991B1B;
        `;
      case "info":
        return `
          background-color: #DBEAFE;
          color: #1E40AF;
        `;
      default:
        return `
          background-color: #E2E8F0;
          color: #475569;
        `;
    }
  }}
`;
